import { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { LAYOUT_HORIZONTAL } from "./constants";
import { fetch_trending } from "../../actions/Trending/dispatchers";
import { SECTIONS } from "../../constants/sections";
import ContentList from "../ContentList/component";
import VerticalCardList from "../VerticalCardList/component";
import DiscoveryPolicy from "../ContentArea/library/DiscoveryPolicy";
import { transformTrendingList } from "../../utils/dataTransform/library";
import featureAttr from "../../utils/featureAttr";

const TrendingList = ({
    items = null,
    section = null,
    fetchSection = false,
    title = "",
    className = "",
    layout = LAYOUT_HORIZONTAL,
    displayPolicy = new DiscoveryPolicy(),
    cardVariant,
    displayType = null,
    listAriaLabel = null,
    cardClickHandler = null,
}) => {
    const dispatch = useDispatch();
    const trendingSections = useSelector((state) => state.trending.sections);
    useEffect(() => {
        if (fetchSection) {
            if (SECTIONS[section]) {
                dispatch(fetch_trending(section));
            }
        }
    }, []);
    const listItems = items || trendingSections[section];
    if (!SECTIONS[section] || !listItems || listItems.length <= 0) {
        return null;
    }

    const featureAttribution = {
        name: "vertical-card-list",
        instance: "trending",
    };

    let finalItems = !items && section ? trendingSections[section] : items;

    let transformedItems = transformTrendingList(finalItems);
    if (transformedItems !== undefined) {
        transformedItems.feature = featureAttribution;
    }

    const componentProps = {
        items: transformedItems,
        className: classNames("trending", className),
        displayType: displayType,
        displayPolicy,
        customTitleBar: null,
        title,
        loadMore: false,
        trackingSection: `contentlist-trending`,
        cardClickHandler: cardClickHandler,
        baseSection: section,
        cardVariant,
        listAriaLabel,
        featureAttribution: featureAttr({ ...featureAttribution }),
    };

    const classes = classNames("trending", className);
    return (
        <div className={classes} data-testid="trendingcontainer">
            <div
                className={classNames("trendingList", className, layout)}
                data-testid="trendingList"
            >
                {layout === LAYOUT_HORIZONTAL ? (
                    <ContentList {...componentProps} />
                ) : (
                    <VerticalCardList {...componentProps} />
                )}
            </div>
        </div>
    );
};

TrendingList.propTypes = {
    items: PropTypes.array,
    // If items property is not provided, item list will be retreived
    // for section from trendingSections property
    section: PropTypes.string,
    fetchSection: PropTypes.bool,
    title: PropTypes.string,
    className: PropTypes.string,
    layout: PropTypes.string,
    displayPolicy: PropTypes.object,
    cardVariant: PropTypes.string,
};

export default TrendingList;
